export type Improvement = {
  version: string
  date: string
  improvements: string[]
}

// Lista mantenida por el equipo: para añadir una versión nueva, basta con
// añadir una entrada al principio del array.
export const IMPROVEMENTS: Improvement[] = [
  {
    version: '2.1.0',
    date: '2026-10-08',
    improvements: [
      'Kits Bedfile: gestión de kits (alta, renombrado por código, descarga y borrado) para administradores',
      'Descarga de kit por código: aviso cuando el kit no existe o ha sido eliminado',
      'Apartado de mejoras implementadas por version',
      'Campo "Patrón de Herencia" de la creacion de Proyectos de PGD y PG-SEQ sin valor predefinido ',
      'Orden para las variantes (Materna > Paterna) en la deteccion directa de PGD y PG-SEQ',
      'Opción de eliminar pacinetes sin proyecto asociado',
      'Exclusion de las coordenadas de los marcadores sexuales en el scope total del panel'

    ],
  },
]